import {post} from '../script/serviceApiPost';

export default{
  async selectPageData(dataRow: any) {
    const result = await post('dict/selectPageData', dataRow);
    return result;
  },
  async updateById(dataRow: any) {
    const result = await post('dict/updateById', dataRow);
    return result;
  },
  async save(dataRow: any) {
    const result = await post('dict/save', dataRow);
    return result;
  },
  
  
 
 
};
